import style from '../Home.module.scss';
import {memo, useCallback, useEffect, useState} from "react";
import className from 'classnames/bind';
import {DatePicker} from "antd";
import dayjs from "dayjs";
import {apiError, handleRequest} from "~/utils";
import {dashboardApi} from "~/api";
import {
    ContentHeader,
    SidebarAccount,
    AccountingCashFlowWidget,
    AccountingSalaryWidget,
    AccountingPendingWidget,
    AccountingContractRankWidget,
} from "../componets";

const cn = className.bind(style);

function DashboardAccountingManager({user, fullTime}) {

    const [time, setTime] = useState(dayjs().startOf('month'));

    const [loading, setLoading] = useState(true);

    const [data, setData] = useState({
        cashFlow : null,
        salary   : null,
        pending  : null,
    });

    const fetchData = useCallback(async (t) => {
        setLoading(true);

        const params = {time: t.startOf('month').unix()};

        const [cashFlowRes, salaryRes, pendingRes] = await Promise.all([
            handleRequest(dashboardApi.accountingCashFlow(params)),
            handleRequest(dashboardApi.accountingSalary(params)),
            handleRequest(dashboardApi.accountingPendingReceipt(params)),
        ]);

        const next = {};

        const [cfErr, cfData] = cashFlowRes;
        if (!apiError('', cfErr, cfData)) next.cashFlow = cfData.data;

        const [salaryErr, salaryData] = salaryRes;
        if (!apiError('', salaryErr, salaryData)) next.salary = salaryData.data;

        const [pendingErr, pendingData] = pendingRes;
        if (!apiError('', pendingErr, pendingData)) next.pending = pendingData.data;

        setData((prev) => ({...prev, ...next}));
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchData(time).then();
    }, [time, fetchData]);

    return (
        <div className={cn('dashboard')}>
            <div className={cn('sidebar')}>
                <SidebarAccount user={user} />
                <div style={{marginTop: 20}}>
                    <AccountingSalaryWidget data={data.salary} loading={loading} />
                </div>
                <div style={{marginTop: 20}}>
                    <AccountingPendingWidget data={data.pending} loading={loading} />
                </div>
            </div>
            <div className={cn('content')}>
                <ContentHeader user={user} fullTime={fullTime} />

                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    flexWrap: 'wrap', gap: 12, marginBottom: 16,
                }}>
                    <h2 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', margin: 0}}>Tổng quan tài chính</h2>
                    <DatePicker
                        picker="month"
                        allowClear={false}
                        format="[Tháng] M / YYYY"
                        value={time}
                        onChange={(d) => d && setTime(d.startOf('month'))}
                        style={{width: 180}}
                    />
                </div>

                <AccountingCashFlowWidget data={data.cashFlow} loading={loading} />

                <div style={{marginTop: 20}}>
                    <AccountingContractRankWidget />
                </div>
            </div>
        </div>
    );
}

export default memo(DashboardAccountingManager);
